import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../features/auth/authSlice';
import uiReducer from './uiSlice';
import communicationMatrixSlice from '../features/communication-matrix/communicationMatrixSlice';
import rolesSlice from '../features/roles/rolesSlice';
import usersSlice from '../features/users/usersSlice';
import notificationsSlice from '../features/notifications/notificationsSlice';
import surveysSlice from '../features/surveys/surveysSlice';
import surveyFormsSlice from '../features/surveys/surveyFormsSlice';
import surveyResponsesSlice from '../features/surveys/surveyResponsesSlice';
import surveyFieldGroupsSlice from '../features/surveys/surveyFieldGroupsSlice';
import surveyStatisticsSlice from '../features/surveys/surveyStatisticsSlice';
import assessmentRecipientsSlice from '../features/surveys/assessmentRecipientsSlice';
import platformPermissionsReducer from '../features/platformPermissions/platformPermissionsSlice';
import organizationStandardsReducer from '../features/organizationStandards/organizationStandardsSlice';
import externalRecipientsSlice from '../features/externalRecipients/externalRecipientsSlice';
import suppliersSlice from '../features/suppliers/suppliersSlice';
import maintenanceSlice from '../features/maintenance/maintenanceSlice';
import documentsSlice from '../features/documents/documentsSlice';
import formTaxonomiesSlice from '../features/formTaxonomies/formTaxonomiesSlice';
import isoImplementationReducer from '../features/iso9001/implementation/isoImplementationSlice';
import isoDictionaryReducer from '../features/isoDictionary/isoDictionarySlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    platformPermissions: platformPermissionsReducer,
    organizationStandards: organizationStandardsReducer,
    ui: uiReducer,
    communicationMatrix: communicationMatrixSlice,
    roles: rolesSlice,
    users: usersSlice,
    notifications: notificationsSlice,
    surveys: surveysSlice,
    surveyForms: surveyFormsSlice,
    surveyResponses: surveyResponsesSlice,
    surveyFieldGroups: surveyFieldGroupsSlice,
    surveyStatistics: surveyStatisticsSlice,
    assessmentRecipients: assessmentRecipientsSlice,
    externalRecipients: externalRecipientsSlice,
    suppliers: suppliersSlice,
    maintenance: maintenanceSlice,
    documents: documentsSlice,
    formTaxonomies: formTaxonomiesSlice,
    isoImplementation: isoImplementationReducer,
    isoDictionary: isoDictionaryReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
